import React from "react";
import { connectSearchBox } from "react-instantsearch-dom";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

export default connectSearchBox(({ refine, currentRefinement }) => {
  return (
    <form>
      <TextField
        type="text"
        label="Sök"
        placeholder="Sök"
        aria-label="Search"
        value={currentRefinement}
        onChange={e => refine(e.target.value)}
        variant="filled"
        InputLabelProps={{ shrink: true }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          )
        }}
        fullWidth
      />
    </form>
  );
});
